import React from 'react';
import { SvgIconProps } from '@material-ui/core';

const BI: React.FC<SvgIconProps> = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 104 91" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M98.3917 45.3872C98.3917 18.8111 75.9663 4.49258 51.7053 4.49258C27.4442 4.49258 5.01916 18.8111 5.01916 45.3872C5.01916 71.9637 27.4445 86.2814 51.7056 86.2814C75.9667 86.2814 98.3917 71.9633 98.3917 45.3872ZM103.349 45.3879C103.349 75.6459 77.5275 90.7755 51.7056 90.7755C25.8838 90.7755 0.0619812 75.6459 0.0619812 45.3879C0.0619812 15.1296 25.8838 0 51.7056 0C77.5275 0 103.349 15.1296 103.349 45.3879ZM100.648 45.3872C100.648 17.506 77.2424 2.23584 51.7053 2.23584C26.1681 2.23584 2.76246 17.506 2.76246 45.3872C2.76246 73.2672 26.1688 88.5381 51.7056 88.5381C77.2424 88.5381 100.648 73.2672 100.648 45.3872ZM25.1025 69.7367C24.1157 69.7367 23.3158 68.9372 23.3158 67.95V22.8228C23.3158 21.836 24.1157 21.0357 25.1025 21.0357H44.4431C52.5692 21.0357 60.5255 24.6342 60.5255 33.7676C60.5255 39.2647 57.6002 42.3252 54.1195 44.2733C59.7576 46.4307 63.2399 49.6993 63.2399 56.3799C63.2399 65.2851 56.0001 69.7367 45 69.7367H25.1025ZM33.7601 40.7254H42.1462C46.8786 40.7254 49.873 39.1944 49.873 35.438C49.873 32.2366 47.366 30.4283 42.8418 30.4283H34.8319C34.2398 30.4283 33.7605 30.908 33.7601 31.5005V40.7254ZM33.7601 59.2727C33.7601 59.8644 34.2398 60.3441 34.8319 60.3441H45C49.7324 60.3441 52.587 58.6752 52.587 54.9177C52.587 51.6494 50.1503 49.6306 44.6516 49.6306H33.7601V59.2727ZM70.4461 69.7367C69.854 69.7367 69.3743 69.2574 69.3743 68.6649V22.1079C69.3747 21.5154 69.854 21.0357 70.4461 21.0357H78.3088C79.2956 21.0357 80.0951 21.8356 80.0955 22.8224V67.95C80.0955 68.9372 79.2956 69.7367 78.3088 69.7367H70.4461Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="61.4296"
        y1="61.1104"
        x2="22.1869"
        y2="9.87109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#074B88" />
        <stop offset="1" stopColor="#1D76B8" />
      </linearGradient>
    </defs>
  </svg>
);

export default BI;
